import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  BRAND, ABOUT_TEXT, WARRANTY_ROWS,
} from "@/lib/constants";

// Fallback mirrors backend DEFAULT_CONTENT so the site renders before/without the API.
export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Electric Rides · Limitless Possibilities",
    title: "Power Up Your Ride with Electric Performance",
    subtitle:
      "Explore our full lineup of e-bikes, fat-tire trail bikes, and electric dirt bikes. Customization is available — and dealer & bulk pricing is offered for qualified buyers.",
  },
  about: {
    heading: "About Us",
    text: ABOUT_TEXT,
    items: ["E-Bikes", "Electric Dirt Bikes", "Buggies", "Go-Karts", "ATVs", "UTVs"],
  },
  warranty: {
    intro: "Every E Ride Power Sports unit is backed by our standard warranty. Coverage details are below.",
    rows: WARRANTY_ROWS,
    footnote:
      "Warranty applies from the date of delivery. Extended warranty options and U.S.-based replacement parts are available. For claims or questions, please contact us.",
  },
  contact: {
    phone: BRAND.phone,
    phoneHref: BRAND.phoneHref,
    email: BRAND.email,
    note: "Prefer to write? Use the form and we'll reply to your email. For wholesale or bulk orders, visit the Dealer Application page.",
  },
  footer: {
    tagline: "Electric e-bikes, dirt bikes, buggies, go-karts, ATVs, and UTVs. Customization available.",
  },
};

const ContentContext = createContext(DEFAULT_CONTENT);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const isPreview =
    typeof window !== "undefined" && new URLSearchParams(window.location.search).get("preview") === "1";

  useEffect(() => {
    const url = isPreview && localStorage.getItem("erp_token") ? "/content/draft" : "/content";
    api
      .get(url)
      .then((r) => setContent({ ...DEFAULT_CONTENT, ...r.data }))
      .catch(() => {});
  }, [isPreview]);

  return (
    <ContentContext.Provider value={content}>
      {isPreview && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] bg-[#8CE63C] text-[#080b08] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full shadow-lg">
          Preview — Draft Changes
        </div>
      )}
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
